var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2 13.04 4.957l-1.714 1.716 1.715-1.716-4.04-1.082-1.083 4.04 2.344-.628-2.343.628-4.04 1.083 1.082 4.04 1.714-1.715-1.715 1.715L2 15.995l2.96 2.958-1.084 4.04 4.041 1.082L9 28.115l4.041-1.083 2.96 2.958 2.922-2.921 4.025 1.045 1.115-4.034 4.062-1.087-1.083-4.04L30 15.995l-2.96-2.957 1.084-4.04-4.041-1.083L23 3.875 18.96 4.957 15.999 2zm6.355 12.293-2.326-.623.622-2.326-2.326.623-.624-2.325L16 11.344l-1.703-1.702-.623 2.325-2.326-.623-3.766-1.008 3.766 1.008.623 2.326-2.325.623 1.703 1.702-1.703 1.703 2.326.622-.622 2.326 2.326-.623.623 2.325L16 20.646l1.535 1.533.595-2.157 2.532.658-.633-2.36 2.325-.622-1.703-1.703 1.703-1.702z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowr);
export default __webpack_public_path__ + "static/media/POWR.1fa07d56f255493db729c961cb7f9350.svg";
export { ForwardRef as ReactComponent };